export type LineHeaderLabelKind =
    | 'corners'
    | 'field-goals'
    | 'touchdowns'
    | 'sets'
    | 'runs'
    | 'points'
    | 'yards'
    | 'cards'
    | 'goals';

const hasWord = (haystack: string, word: string): boolean => {
    return new RegExp(`\\b${word}\\b`).test(haystack);
};

/**
 * Label for the first header cell above line values (1.5, 2.5…).
 * Only when the unit is clear from name/template — no broad O/U → Goals fallback.
 * Keyword order matters (field goals before goals, booking points before cards, etc.).
 */
export const resolveLineHeaderLabel = (
    groupName: string,
    templateId: string = '',
    templateName: string = ''
): LineHeaderLabelKind | null => {
    const haystack = [groupName, templateId, templateName].join(' ').toLowerCase();

    if (haystack.includes('corner')) {
        return 'corners';
    }
    if (haystack.includes('field goal') || haystack.includes('field-goal')) {
        return 'field-goals';
    }
    if (haystack.includes('touchdown')) {
        return 'touchdowns';
    }
    if (hasWord(haystack, 'set') || hasWord(haystack, 'sets') || haystack.includes('total-sets')) {
        return 'sets';
    }
    if (hasWord(haystack, 'run') || hasWord(haystack, 'runs') || haystack.includes('total-runs')) {
        return 'runs';
    }
    if (haystack.includes('point')) {
        return 'points';
    }
    if (haystack.includes('yard')) {
        return 'yards';
    }
    if (haystack.includes('card')) {
        return 'cards';
    }
    if (haystack.includes('goal')) {
        return 'goals';
    }
    // Combo markets about goals that omit the word "goal" (e.g. Double Chance & Over/Under).
    if (haystack.includes('double chance') || haystack.includes('double-chance')) {
        return 'goals';
    }
    // American sports often use plural "Totals Over/Under" for points without saying "points".
    // Do not match singular "Total …" — that covers any unit (attempts, receptions, etc.).
    if (
        hasWord(haystack, 'totals') &&
        (haystack.includes('over/under') || haystack.includes('over-under') || haystack.includes('over under'))
    ) {
        return 'points';
    }

    return null;
};
